<div class="main-page">
    <div class="container">
        <ngx-spinner></ngx-spinner>
        <div class="plans-area">
            <div class="innerPage plans-area-inner">
                <form #personalForm="ngForm" [formGroup]="form" id="msform" (ngSubmit)="onSubmit(form.value)" class="pc-form">
                    <div class="pc-header">
                      <div>
                        <div class="pc-title">
                          <span class="pc-title-icon" aria-hidden="true"><i class="fa fa-envelope-open-text"></i></span>
                          Create Postcard
                        </div>
                        <div class="pc-subtitle">Send a quick update to your customers</div>
                      </div>
                      <div class="pc-badge">
                        <i class="fa fa-id-card" aria-hidden="true"></i>
                        Customer Postcards
                      </div>
                    </div>

                    <div class="form-group pc-field">
                        <label for="postcardTitle"><i class="fa fa-tag" aria-hidden="true"></i> Title</label>
                        <input
                          type="text"
                          class="form-control pc-input"
                          id="postcardTitle"
                          placeholder="e.g. Weekend special, New menu, Holiday hours…"
                          formControlName="name"
                          [class.is-invalid]="(personalForm.submitted && f['name'].invalid)"
                        />
                        <div class="pc-meta">
                          <small class="pc-error" *ngIf="f['name'].invalid && f['name'].touched">Required</small>
                          <small class="pc-count">{{ (form.get('name')?.value?.length || 0) }}/120</small>
                        </div>
                    </div>

                    <div class="form-group pc-field">
                        <label for="postcardDescription"><i class="fa fa-align-left" aria-hidden="true"></i> Description</label>
                        <textarea
                          id="postcardDescription"
                          rows="6"
                          class="form-control pc-input"
                          placeholder="Write your message..."
                          formControlName="description"
                          [class.is-invalid]="(personalForm.submitted && f['description'].invalid)"
                        ></textarea>
                        <div class="pc-meta">
                          <small class="pc-error" *ngIf="f['description'].invalid && f['description'].touched">Required</small>
                          <small class="pc-count">{{ (form.get('description')?.value?.length || 0) }}/1000</small>
                        </div>
                    </div>

                    <div class="pc-actions">
                        <button type="button" (click)="goBack()" class="pc-btn pc-btn--ghost">
                          <i class="fa fa-arrow-left" aria-hidden="true"></i>
                          Back
                        </button>
                        <button type="submit" class="pc-btn pc-btn--primary">
                          <i class="fa fa-paper-plane" aria-hidden="true"></i>
                          Create
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>